module.exports = {
      id: "logo-small-usage",
      viewBox: "0 0 192 28",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }